// @ts-strict-ignore
/* eslint-env node */

import mpColors from '../stylesheets/mixins/colors.json';

export const activeColorScheme = {
  charts: {
    default: [
      {
        primary: mpColors[`$chart1`],
        secondary: mpColors[`$white`], // usually the text color
      },
      {
        primary: mpColors[`$chart2`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart3`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart4`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart5`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart6`],
        secondary: mpColors[`$gray5`],
      },
      {
        primary: mpColors[`$chart7`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart8`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart9`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart10`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart11`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart12`],
        secondary: mpColors[`$white`],
      },
    ],

    previousComparison: [
      {
        primary: mpColors[`$chart1`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$gray3`],
        secondary: mpColors[`$gray5`],
      },
    ],

    campaignMessages: [
      {
        primary: mpColors[`$chart1`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart2`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart3`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart4`],
        secondary: mpColors[`$white`],
      },
    ],

    campaignEmails: [
      {
        primary: mpColors[`$chart1`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart2`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart3`],
        secondary: mpColors[`$gray4`],
      },
    ],
  },

  // TODO: reconcile this list with the variables in
  // iron/common/stylesheets/mixins/colors.styl
  gray0: `var(--gray0)`,
  gray0RGB: `var(--gray0-rgb)`,
  gray1: `var(--gray1)`,
  gray1RGB: `var(--gray1-rgb)`,
  gray2: `var(--gray2)`,
  gray3: `var(--gray3)`,
  gray4: `var(--gray4)`,
  gray5: `var(--gray5)`,

  blue1: `var(--blue1)`,
  blue2: `var(--blue2)`,
  blue3: `var(--blue3)`,
  red1: `var(--red1)`,
  red2: `var(--red2)`,
  red3: `var(--red3)`,
  green1: `var(--green1)`,
  green2: `var(--green2)`,
  green3: `var(--green3)`,
  orange1: `var(--orange1)`,
  orange2: `var(--orange2)`,
  orange3: `var(--orange3)`,
  blue1RGB: `var(--blue1-rgb)`,

  primaryTextColor: `var(--primary-text-color)`,
  secondaryTextColor: `var(--secondary-text-color)`,
  tertiaryTextColor: `var(--tertiary-text-color)`,

  backgroundColor: `var(--background-color)`,
  secondaryBackgroundColor: `var(--secondary-background-color)`,

  componentOutlineColor: `var(--component-outline-color)`,

  chartAxisLineColor: `var(--chart-axis-line-color)`,
  chartAxisTickMarkerColor: `var(--chart-axis-tick-marker-color)`,

  positive: mpColors[`$green1`],
  negative: mpColors[`$red1`],

  heatSteps: {
    correlatePositive: [
      {
        step: 0.05,
        primary: mpColors[`$positive-scale0`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.1,
        primary: mpColors[`$positive-scale1`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.2,
        primary: mpColors[`$positive-scale2`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.3,
        primary: mpColors[`$positive-scale3`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.4,
        primary: mpColors[`$positive-scale4`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.5,
        primary: mpColors[`$positive-scale5`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.6,
        primary: mpColors[`$positive-scale6`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.8,
        primary: mpColors[`$positive-scale7`],
        secondary: mpColors[`$white`],
      },
      {
        step: Number.MAX_SAFE_INTEGER,
        primary: mpColors[`$positive-scale8`],
        secondary: mpColors[`$white`],
      },
    ],

    correlateNegative: [
      {
        step: -0.05,
        primary: mpColors[`$negative-scale0`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.1,
        primary: mpColors[`$negative-scale1`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.2,
        primary: mpColors[`$negative-scale2`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.3,
        primary: mpColors[`$negative-scale3`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.4,
        primary: mpColors[`$negative-scale4`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.5,
        primary: mpColors[`$negative-scale5`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.6,
        primary: mpColors[`$negative-scale6`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.8,
        primary: mpColors[`$negative-scale7`],
        secondary: mpColors[`$white`],
      },
      {
        step: Number.MIN_SAFE_INTEGER,
        primary: mpColors[`$negative-scale8`],
        secondary: mpColors[`$white`],
      },
    ],

    retention: [
      {
        step: 1 / 10,
        primary: mpColors[`$sequence-0`],
        secondary: `var(--gray5)`,
      },
      {
        step: 2 / 10,
        primary: mpColors[`$sequence-1`],
        secondary: `var(--gray5)`,
      },
      {
        step: 3 / 10,
        primary: mpColors[`$sequence-2`],
        secondary: `var(--gray5)`,
      },
      {
        step: 4 / 10,
        primary: mpColors[`$sequence-3`],
        secondary: `var(--gray5)`,
      },
      {
        step: 5 / 10,
        primary: mpColors[`$sequence-4`],
        secondary: `var(--gray5)`,
      },
      {
        step: 6 / 10,
        primary: mpColors[`$sequence-5`],
        secondary: `var(--gray5)`,
      },
      {
        step: 7 / 10,
        primary: mpColors[`$sequence-6`],
        secondary: `var(--gray5)`,
      },
      {
        step: 8 / 10,
        primary: mpColors[`$sequence-7`],
        secondary: mpColors[`$white`],
      },
      {
        step: 9 / 10,
        primary: mpColors[`$sequence-8`],
        secondary: mpColors[`$white`],
      },
      {
        step: 1,
        primary: mpColors[`$sequence-9`],
        secondary: mpColors[`$white`],
      },
      {
        step: `incomplete`,
        primary: `var(--gray0)`,
        secondary: `var(--gray3)`,
      },
      {
        step: `zeroBucket`,
        primary: mpColors[`$sequence-0`],
        secondary: mpColors[`$white`],
      },
    ],
  },

  otherSegment: {
    primary: mpColors[`$other-segment`],
    secondary: mpColors[`$other-segment-secondary`],
  },
} as const;

// old color scheme had variations that have since been deprecated
// map the keys to the correct color set in the new color scheme for backward compatibility
// left-hand-side references can be removed throughout all projects once new color scheme is fully rolled out
activeColorScheme.charts[`stackedBarChart`] = activeColorScheme.charts[`default`];
activeColorScheme.charts[`insights`] = activeColorScheme.charts[`default`];
activeColorScheme.charts[`pieChart`] = activeColorScheme.charts[`default`];
activeColorScheme[`chartTooltipPositive`] = activeColorScheme[`positive`];
activeColorScheme[`chartTooltipNegative`] = activeColorScheme[`negative`];

type RGB = {
  r: number;
  g: number;
  b: number;
};

export function rgbFromHexString(hexString: string): RGB {
  const parts = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexString);
  return (
    parts && {
      r: parseInt(parts[1], 16),
      g: parseInt(parts[2], 16),
      b: parseInt(parts[3], 16),
    }
  );
}

export function rgbaStringFromHexString(hexString: string, alpha: number) {
  const parts = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexString);
  return `rgba(${parseInt(parts[1], 16)}, ${parseInt(parts[2], 16)}, ${parseInt(parts[3], 16)}, ${alpha})`;
}

export function getChartSegmentColorCombo(idx: number, themeColors?: string[]): {primary: string; secondary: string} {
  if (themeColors) {
    const color = themeColors[idx % themeColors.length];
    return {primary: color, secondary: color};
  }
  const defaultColors = activeColorScheme.charts.default;
  return defaultColors[idx % defaultColors.length];
}

export function getCorrelatePhiColorCombo(phi: number) {
  const steps =
    phi >= 0 ? activeColorScheme.heatSteps[`correlatePositive`] : activeColorScheme.heatSteps[`correlateNegative`]; // eslint-disable-line no-multi-spaces
  return steps.find((s) => (phi >= 0 ? phi < s.step : phi > s.step)); // eslint-disable-line no-multi-spaces
}

export function getRetentionColorCombo(heatPercent: number, zeroBucket = false, incomplete = false) {
  // @heatPercent is a decimal in the range [0,1]
  const steps = activeColorScheme.heatSteps[`retention`];
  return (
    (incomplete && steps.find((s) => s.step === `incomplete`)) ||
    (zeroBucket && steps.find((s) => s.step === `zeroBucket`)) ||
    steps.find((s) => heatPercent <= (s.step as number))
  );
}

export const colors = activeColorScheme;
export {mpColors};

export function validateHexColor(color: string): boolean {
  const hexColorRegex = /^#([A-Fa-f0-9]{6})$/;
  return hexColorRegex.test(color);
}

/**
 * Generates a foreground color that will contrast with a given background
 * @see https://www.w3.org/TR/AERT/#color-contrast
 */
export function getAccessibleForegroundColor(backgroundColor: string) {
  const rgb = rgbFromHexString(backgroundColor);
  const contrast = (Math.round(rgb.r * 299) + Math.round(rgb.g * 587) + Math.round(rgb.b * 114)) / 1000;
  return contrast >= 128 ? mpColors[`$gray5`] : mpColors[`$gray0`];
}
